import type { CreatePaymentPayload, CreatePaymentResult, VerifyPaymentResult } from '@/types/payment';
import { getSession } from '@/lib/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()?.replace(/\/$/, '');
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

const functionUrl = (name: string) => {
  if (!supabaseUrl) throw new Error('Supabase is not configured');
  return `${supabaseUrl}/functions/v1/${name}`;
};

async function postFunction<T>(name: string, body: unknown): Promise<T> {
  if (!supabaseUrl || !publishableKey) {
    throw new Error('מערכת התשלום עדיין לא הוגדרה.');
  }

  const session = await getSession();
  const response = await fetch(functionUrl(name), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: publishableKey,
      ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => null) as { error?: string; message?: string } | T | null;
  if (!response.ok) {
    const message = data && typeof data === 'object' && ('error' in data || 'message' in data)
      ? String((data as { error?: string; message?: string }).error || (data as { message?: string }).message || '')
      : '';
    throw new Error(message || 'לא ניתן להתחיל את התשלום כרגע. נסו שוב בעוד רגע.');
  }
  return data as T;
}

export async function createHypPayment(payload: CreatePaymentPayload): Promise<CreatePaymentResult> {
  return postFunction<CreatePaymentResult>('hyp-create-payment', payload);
}

export async function verifyHypPayment(search: string): Promise<VerifyPaymentResult> {
  const params = Object.fromEntries(new URLSearchParams(search.startsWith('?') ? search.slice(1) : search));
  return postFunction<VerifyPaymentResult>('hyp-verify-payment', { params });
}
